import Section from '../common/Section';

export default function About() {
  return (
    <Section className="bg-white">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-5xl md:text-6xl font-heading font-bold mb-6">
              关于我
            </h2>
            <p className="text-lg leading-relaxed mb-4">
              你好！我是 Keeeer，一名充满热情的开发者，热衷于创造优雅且实用的数字解决方案。
            </p>
            <p className="text-lg leading-relaxed mb-4">
              通过代码，我将创意转化为现实，解决实际问题，改善用户体验。
              在技术旅程中，我专注于前端开发、用户体验设计和现代Web技术栈。
              我相信好的产品不仅要功能完善，更要让用户感到愉悦。
            </p>
            <p className="text-lg leading-relaxed">
              当我不在编码时，你可以在阅读技术文章、探索开源项目或思考下一个创意时找到我。
            </p>
          </div>
          <div className="relative">
            <div className="aspect-square bg-gradient-to-br from-primary/30 to-cta/30 border-3 border-black shadow-neubrutal rounded-lg flex items-center justify-center">
              <div className="text-9xl font-heading font-bold">👨‍💻</div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-secondary border-3 border-black shadow-neubrutal hidden md:block"></div>
          </div>
        </div>
      </div>
    </Section>
  );
}
